// extracted by mini-css-extract-plugin
export default {"root":"jjDHTsJ5jptHjTEjJ_Ip","title":"rS2stI5YaLzVq74j1QyG","participants":"hVeFWVY3xKDVZcDfDhLm","duration":"iCHB8WRjE98_36IVR1MZ"};